// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Uif8D","img":"styles_img__KHGAO","title":"styles_title__BkrbC"};